"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var semantic_ui_react_1 = require("semantic-ui-react");
var react_cookie_1 = require("react-cookie");
var react_content_loader_1 = __importDefault(require("react-content-loader"));
var helperFunctions_1 = require("../helperFunctions");
var feedActions = __importStar(require("./feedActions"));
var postActions_1 = require("../../post/postActions");
var PostsList_1 = __importDefault(require("./components/PostsList"));
var RatingPopup_1 = __importDefault(require("./components/RatingPopup"));
var Feed = /** @class */ (function (_super) {
    __extends(Feed, _super);
    function Feed(props) {
        var _this = _super.call(this, props) || this;
        _this.onScroll = function (_a) {
            var target = _a.target;
            var isLoading = _this.props.isLoading;
            // localStorage.setItem('communityScroll', target.scrollTop)
            if (window.innerHeight + target.scrollTop >= target.scrollHeight - 4000 &&
                !isLoading) {
                _this.uploadNewPosts();
            }
        };
        _this.defaultClickHandler = _this.defaultClickHandler.bind(_this);
        _this.ratingDisplayTrigger = _this.ratingDisplayTrigger.bind(_this);
        _this.closeRatingModal = _this.closeRatingModal.bind(_this);
        _this.state = {
            currentPage: 0,
            tabNameSame: "",
            listener: false,
            ratingModalShow: false,
        };
        return _this;
    }
    Feed.prototype.componentDidMount = function () {
        var tabName = this.props.tabName;
        (0, helperFunctions_1.setPageForGoogleAnalytics)("articles");
        var el = document.querySelector(".app-body");
        el.addEventListener("scroll", this.onScroll);
        this.uploadNewPosts();
        this.setState({ tabNameSame: tabName, listener: true });
    };
    Feed.prototype.componentDidUpdate = function (props) {
        var _a = this.props, queryParams = _a.queryParams, isEnd = _a.isEnd, loadmore = _a.loadmore;
        var listener = this.state.listener;
        if (props.queryParams != queryParams) {
            this.queryParamsChanged();
        }
        if (loadmore === false) {
            var el = document.querySelector(".app-body");
            el.removeEventListener("scroll", this.onScroll);
        }
        if (isEnd && listener) {
            var el = document.querySelector(".app-body");
            el.removeEventListener("scroll", this.onScroll);
        }
        if (!isEnd && !listener) {
            var el = document.querySelector(".app-body");
            el.addEventListener("scroll", this.onScroll);
        }
    };
    Feed.prototype.componentWillUnmount = function () {
        var clearPosts = this.props.clearPosts;
        clearPosts();
        var el = document.querySelector(".app-body");
        el.removeEventListener("scroll", this.onScroll);
    };
    Feed.prototype.queryParamsChanged = function () {
        var clearPosts = this.props.clearPosts;
        clearPosts();
        this.uploadNewPosts(1);
    };
    Feed.prototype.uploadNewPosts = function (page) {
        var _a = this.props, getPosts = _a.getPosts, cookies = _a.cookies, queryParams = _a.queryParams, tabName = _a.tabName, isEnd = _a.isEnd, isAuthorized = _a.isAuthorized;
        var _b = this.state, tabNameSame = _b.tabNameSame, currentPage = _b.currentPage;
        var pageName = window.location.pathname;
        var newPage = page ? page : tabNameSame != tabName ? 1 : currentPage + 1;
        isEnd
            ? this.setState({ listener: false })
            : this.setState({ listener: true });
        this.setState({ currentPage: newPage, tabNameSame: tabName });
        //getPosts({ page: newPage, queryParams }, cookies.get('trybe_jwt'));
        if (tabName == "Latest") {
            getPosts({ page: newPage, queryParams: queryParams }, pageName == "/profile/my-articles/" ? cookies.get("trybe_jwt") : null, tabName);
        }
        else {
            getPosts({ page: newPage, queryParams: queryParams }, pageName == "/profile/my-articles/" ? cookies.get("trybe_jwt") : null, tabName);
        }
        // const pageName = window.location.pathname;
        // if (pageName == '/community/') {
        //   let feedScroll = localStorage.getItem('communityScroll')
        //   console.log(feedScroll);
        //   console.log('helo wordl')
        //   if (feedScroll) {
        //     document.querySelector(".app-body").scrollTo(0, feedScroll)
        //   }
        // }
    };
    Feed.prototype.defaultClickHandler = function (postInfo) {
        var setPost = this.props.setPost;
        setPost(postInfo);
        //history.push(`/${postInfo.slug}`);
    };
    Feed.prototype.ratingDisplayTrigger = function (articleId, rating) {
        if (rating > 0) {
            var getRatings = this.props.getRatings;
            getRatings(articleId);
            this.setState(function (prevState) { return ({
                ratingModalShow: !prevState.ratingModalShow,
            }); });
        }
    };
    Feed.prototype.closeRatingModal = function () {
        this.setState({
            ratingModalShow: false,
        });
    };
    Feed.prototype.render = function () {
        var _a = this.props, postsData = _a.postsData, clickHandler = _a.clickHandler, isLoading = _a.isLoading, isEnd = _a.isEnd, noAuthor = _a.noAuthor, follow_count = _a.follow_count, isLoadingFollowers = _a.isLoadingFollowers, isMyFeed = _a.isMyFeed, isAuthorized = _a.isAuthorized, tabName = _a.tabName, ratings = _a.ratings, ratingsLoading = _a.ratingsLoading;
        var ratingModalShow = this.state.ratingModalShow;
        var pageName = window.location.pathname;
        return ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Container, __assign({ className: "feed cz-con-new pre_loader_grid" }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Row, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, __assign({ width: 16 }, { children: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Container, { children: [postsData[0] ? ((0, jsx_runtime_1.jsx)(PostsList_1.default, { className: "posts-list", posts: postsData, isLoaderActive: isLoading, noAuthor: noAuthor, clickHandler: clickHandler ? clickHandler : this.defaultClickHandler })) : (!isEnd && ((0, jsx_runtime_1.jsx)("div", __assign({ class: "ui segment my-feeds-loader" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ class: "ui active dimmer" }, { children: (0, jsx_runtime_1.jsxs)(react_content_loader_1.default, __assign({ speed: 2, style: { width: "100%" }, viewBox: "0 0 476 124", backgroundColor: "#1b1b1b", foregroundColor: "#2f2f2f" }, { children: [(0, jsx_runtime_1.jsx)("rect", { x: "45", y: "20", rx: "3", ry: "3", width: "90", height: "4" }), (0, jsx_runtime_1.jsx)("rect", { x: "45", y: "30", rx: "3", ry: "3", width: "30", height: "4" }), (0, jsx_runtime_1.jsx)("rect", { x: "10", y: "61", rx: "3", ry: "3", width: "200", height: "4" }), (0, jsx_runtime_1.jsx)("rect", { x: "10", y: "71", rx: "3", ry: "3", width: "150", height: "4" }), (0, jsx_runtime_1.jsx)("rect", { x: "10", y: "81", rx: "3", ry: "3", width: "100", height: "4" }), (0, jsx_runtime_1.jsx)("circle", { cx: "25", cy: "25", r: "15" })] })) })) })))), isLoading && ((0, jsx_runtime_1.jsx)("div", __assign({ class: "ui segment my-feeds-loader" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ class: "ui active dimmer" }, { children: (0, jsx_runtime_1.jsxs)(react_content_loader_1.default, __assign({ speed: 2, style: { width: "100%" }, viewBox: "0 0 476 124", backgroundColor: "#1b1b1b", foregroundColor: "#2f2f2f" }, { children: [(0, jsx_runtime_1.jsx)("rect", { x: "45", y: "20", rx: "3", ry: "3", width: "90", height: "4" }), (0, jsx_runtime_1.jsx)("rect", { x: "45", y: "30", rx: "3", ry: "3", width: "30", height: "4" }), (0, jsx_runtime_1.jsx)("rect", { x: "10", y: "61", rx: "3", ry: "3", width: "200", height: "4" }), (0, jsx_runtime_1.jsx)("rect", { x: "10", y: "71", rx: "3", ry: "3", width: "150", height: "4" }), (0, jsx_runtime_1.jsx)("rect", { x: "10", y: "81", rx: "3", ry: "3", width: "100", height: "4" }), (0, jsx_runtime_1.jsx)("circle", { cx: "25", cy: "25", r: "15" })] })) })) })))] }) })) }) }) })));
    };
    return Feed;
}(react_1.PureComponent));
exports.default = (0, react_cookie_1.withCookies)((0, react_router_dom_1.withRouter)((0, react_redux_1.connect)(function (state, ownProps) { return ({
    isLoading: state.feed.loading,
    isEnd: state.feed.isEnd,
    noAuthor: state.feed.noAuthor,
    postsData: state.feed.posts,
    isAuthorized: state.user.userIsLogged,
    cookies: ownProps.cookies,
    ratings: state.feed.ratings,
    ratingsLoading: state.feed.ratingsLoading,
}); }, function (dispatch) { return ({
    getPosts: function (params, token, type) {
        dispatch(feedActions.getPostsRoutine({ params: params, token: token, type: type }));
    },
    getRatings: function (postId) {
        dispatch(feedActions.getRatingsRoutine(postId));
    },
    clearPosts: function () {
        dispatch(feedActions.clearPostsRoutine());
    },
    setPost: function (postInfo) {
        dispatch((0, postActions_1.setPostInfo)(postInfo));
    },
}); })(Feed)));
